module.exports = __webpack_public_path__ + "img/logo_title.9f7b425a.svg";